import css from "../../css/common/paginator.module.css";

import React from "react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import queryString from "query-string";

const Paginator = (props) => {
    const { onPageChange, pages, page, href } = props;

    return (
        <div className={css.paginator}>
            <ReactPaginate
                previousLabel={"."}
                nextLabel={"."}
                breakLabel={"..."}
                pageCount={pages}
                forcePage={page - 1}
                disableInitialCallback={true}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={onPageChange}
                containerClassName={css.container}
                pageClassName={css.page}
                pageLinkClassName={css.pageLink}
                breakClassName={css.break}
                breakLinkClassName={css.breakLink}
                activeClassName={css.activePage}
                activeLinkClassName={css.activePageLink}
                previousClassName={css.previous}
                nextClassName={css.next}
                previousLinkClassName={css.previousLink}
                nextLinkClassName={css.nextLink}
                ariaLabelBuilder={(page) => {
                    return "Page " + page;
                }}
                hrefBuilder={(page) => {
                    if (!href) {
                        return page;
                    }

                    let url = href.pathname;

                    if (href.query) {
                        let { query } = href;
                        query["page"] = page;

                        url += "?" + queryString.stringify(query);
                    }

                    return url;
                }}
            />
        </div>
    );
};

Paginator.propTypes = {
    onPageChange: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    href: PropTypes.object.isRequired,
};

export default Paginator;
